import Component from '../Component';
import Inspector from '../inspector/Inspector';
import Fragment from '../inspector/Fragment';

const { MediaPlaceholder } = wp.blockEditor;

export default class Background extends Component {
  render() {
    if (this.isView()) {
      return this.renderView();
    }

    // Selected
    let { image, videos } = this.attr() || {};

    return (
      <Fragment>
        {this.renderView()}
        <Inspector>
          <Inspector.Body
            title={this.props.title || this.props.label || 'Background'}
          >
            <Inspector.Row>
              <MediaPlaceholder
                icon="format-image"
                onSelect={val => {
                  let attr = this.attr() || {};

                  attr.image = {
                    id: val.id,
                    url: val.url,
                    sizes: val.sizes,
                  };

                  attr.timestamp = Date.now();

                  this.setAttr(attr);
                }}
                allowedTypes={['image']}
                multiple={false}
                value={image}
              />
            </Inspector.Row>

            {this.props.video && (
              <Inspector.Row>
                <div style={{ width: '100%' }}>
                  <MediaPlaceholder
                    icon="format-video"
                    onSelect={val => {
                      let attr = this.attr() || {};

                      attr.videos = val
                        .sort((a, b) => {
                          // Diferent types
                          if (a.subtype != b.subtype) {
                            return a.subtype == 'mp4' ? -1 : 1;
                          }

                          // Width
                          return a.width < b.width ? -1 : 1;
                        })
                        .map(video => {
                          return {
                            id: video.id,
                            url: video.url,
                            width: video.width,
                            mime: video.mime,
                          };
                        });

                      attr.timestamp = Date.now();

                      this.setAttr(attr);
                    }}
                    allowedTypes={['video']}
                    multiple={true}
                    labels={{ title: 'Videos' }}
                    value={videos}
                  />
                  <p className="components-base-control__help">
                    Allows to upload multiple video files
                  </p>
                </div>
              </Inspector.Row>
            )}
          </Inspector.Body>
        </Inspector>
      </Fragment>
    );
  }

  renderView() {
    let { image, videos } = this.attr() || {};

    if (videos) {
      return this.renderVideos(videos, image);
    }

    if (image) {
      return this.renderImage(image);
    }

    return null;
  }

  renderImage(image) {
    return (
      <div className="background">
        <picture>
          {image.sizes && Object.entries(image.sizes).map(([key, size]) => {
            return (
              <source
                key={key}
                srcSet={size.url}
                media={`(max-width: ${size.width}px)`}
              />
            );
          })}
          <img srcSet={image.url} alt="" title="" />
        </picture>
      </div>
    );
  }

  renderVideos(videos, image = null) {
    return (
      <div className="background">
        <video autoPlay playsInline loop muted poster={image ? image.url : ''}>
          {Object.entries(videos).map(([key, video]) => {
            return <source key={key} src={video.url} type={video.mime} />;
          })}
        </video>
      </div>
    );
  }
}
